function PolicyFormCtrl($scope, $controller, $location, $timeout, $state, $filter, IconsService, GeneralUtilsService) {

	$scope.triggerConfig = {
		label: 'Track',
		path: 'track',
		template: "<div id='trigger_{{tableConfig.ruleAction + $parent.$index}}' class='inline-block' ng-click='tableConfig.editTrigger(item,tableConfig.ruleAction + $parent.$index)'><span ng-show='!item.trigger' class='action-link'>Select</span><span ng-show='item.trigger'><span class='glyphicon glyphicon-alert'></span>&nbsp;<span class='action-link'>Alert:{{item.priority | capitalize}}</span></span></div>",
		noSort: true
	};

	var icons = IconsService.getIcons("policy");
	$scope.hideAdminTable = true;
	$scope.datamodified = false;
	$scope.exceptionsdatamodified = false;

	$scope.grouplookup = {
		method: 'POST',
		icons: icons,
	};

	$scope.parseLocalRoutingRules = function () {
		var items = [];
		if ($scope.site && $scope.site.localRoutingRules) {
			items = $scope.site.localRoutingRules || [];
		}
		return items;

	};

	$scope.directions = [
		{
			value: 'TO', name: 'to',
		},
		{
			value: 'FROM', name: 'From',
		},
		{
			value: 'BOTH', name: 'both',
		},
	];

	var rulesDef = {

		access: {
			enabledMessage: 'WAN Firewall',
			generalFetch: true,
			sortButton: true,
			postSave: function() {
                checkNewFw();
            },
			destination: {
				class: 'entry-list',
				label: 'Destination',
				path: 'destination',
				template: "<span><entry-list items='item.destination' root='item' field='destination' id='destination_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
				noSort: true
			},
			ruleCollection: 'accessRules',
			enabledAttrib: 'accessRulesEnabled',
			type: 'AccessRule',
			titleSearch: true,
			title: 'Access Rules',
			defaultAction: 'ALLOW',
			exceptionAction: 'BLOCK',
			redirect: window.location.origin + '/#!/' + $state.params.accountId + '/connectionRules',
			confirm: 'internal connectivity restrictions',
			tableTitle: 'Connections',
			constraints: ['service', 'time', 'limit_bw', 'ports', 'custom_apps'],
			restrictionType: 'accessRules',
			fields: [
				{
					class: 'toggle-status',
					label: 'Status',
					path: 'enabled',
					template: "<span ng-show='item.id > 0'><span class='current'>{{item.enabled? 'Enabled' : 'Disabled'}}</span><span class='change-status' ng-click='tableConfig.toggleRuleStatus(item, item.enabled)'>{{item.enabled? 'Disable' : 'Enable'}}</span></span>",
					noSearch: true
				},
				{
					class: 'entry-list',
					label: 'Source',
					path: 'source',
					template: '<span><entry-list' +
					" items='item.source' root='item' field='source' id='source_{{tableConfig.ruleAction + $parent.$index}}'  add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true,
					searchField: 'name'
				},
				{
					class: 'direction',
					label: 'Direction',
					path: 'dir',
					template: "<img ng-click='tableConfig.changeDir(item)' alt='Click to change direction' ng-src='/public/images/{{item.dir}}.png'/>",
					noSort: true,
					noSearch: true
				},
				{
					class: 'entry-list',
					label: 'Destination',
					path: 'destination',
					template: "<span><entry-list items='item.destination' root='item' field='destination' id='destination_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true,
					searchField: 'name'
				},
				{
					class: 'constraint',
					label: 'Limit to',
					path: 'constraint',
					template: "<span><constraint id='tableConfig.ruleAction' item='item' config='tableConfig' index='$parent.$index'/></span>",
					noSort: true,
					noSearch: true
				},
				{
					label: 'Description',
					path: 'description',
					template: "<textarea  ng-model='item.description'></textarea>",
					noSort: true
				},
				$scope.triggerConfig,
				{
					label: 'Last Modified',
					path: 'lastModified',
					template: "<span><time am-time-ago='item.lastModified'></time></span>",
					noSort: false,
					noSearch: true
				},
			],
		},
		app: {
			enabledMessage: 'Internet Firewall',
			generalFetch: true,
			sortButton: true,
			destination: {
				class: 'entry-list',
				label: 'Applications',
				path: 'apps',
				template: "<span><entry-list items='item.dest' root='item' field='dest' capitalize=true id='apps_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.selectApp(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
				noSort: true
			},
			postSave: function() {
			    checkNewFw();
			},
			ruleCollection: 'appRules',
			enabledAttrib: 'appRulesEnabled',
			type: 'AppRule',
			title: 'Application Rules',
			titleSearch: true,
			defaultAction: 'BLOCK',
			exceptionAction: 'ALLOW',
			redirect: window.location.origin + '/#!/' + $state.params.accountId + '/appRules',
			confirm: 'application control',
			tableTitle: 'Applications',
			constraints: ['time', 'limit_bw'],
			restrictionType: 'appRules',
			fields: [
				{
					class: 'toggle-status',
					label: 'Status',
					path: 'enabled',
					template: "<span ng-show='item.id > 0'><span class='current'>{{item.enabled? 'Enabled' : 'Disabled'}}</span><span class='change-status' ng-click='tableConfig.toggleRuleStatus(item, item.enabled)'>{{item.enabled? 'Disable' : 'Enable'}}</span></span>",
					noSearch: true
				},
				{
					class: 'entry-list',
					label: 'Source',
					path: 'source',
					template: "<span><entry-list items='item.source' root='item' field='source' id='source_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true,
					searchField: 'name'
				},
				{
					class: 'entry-list',
					label: 'Applications',
					path: 'dest',
					template: "<span><entry-list items='item.dest' root='item' field='dest' capitalize=true id='apps_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.selectApp(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true,
					searchField: 'display_name'
				},
				{
					class: 'constraint',
					label: 'Limit to',
					path: 'constraint',
					template: "<span><constraint id='tableConfig.ruleAction' item='item' config='tableConfig' index='$parent.$index'/></span>",
					noSort: true,
					noSearch: true
				},
				{
					label: 'Description',
					path: 'description',
					template: "<textarea ng-model='item.description' rows='3'></textarea>",
					noSort: true
				},
				$scope.triggerConfig,
				{
					label: 'Last Modified',
					path: 'lastModified',
					template: "<span><time am-time-ago='item.lastModified'></time></span>",
					noSort: false,
					noSearch: true
				},
			],
			preSave: function (rule) {
				var newApps = [];
				rule.fqdns = [];
				rule.topLevelDomains = [];
				rule.ports = [];
				rule.ips = [];

				for (var i = 0;rule.dest[i];i++) {
					var app = rule.dest[i];

					switch (app.type) {
						case 'FQDN':
							rule.fqdns.push(app.id);
							break;
						case 'TLD':
							rule.topLevelDomains.push(app.id);
							break;
						case 'IP':
							rule.ips.push(app.id);
							break;
						case 'PORT':
							rule.ports.push(app.id);
							break;
						default:
							newApps.push(app);
					}
				}

				rule.ips = rule.ips.join(',');
				rule.ports = rule.ports.join(',');
				rule.apps = newApps;
			},
			typeProcessData: function(items) {
				if (items) {
					for (var i = 0;items[i];i++) {
						var item = items[i];
						item.dest = [];
						if (item.fqdns) {
							item.fqdns.forEach(function (fqdn) {
								item.dest.push({"display_name": fqdn, "type": "FQDN", id: fqdn, "name": fqdn})
							});
						}

						if (item.topLevelDomains) {
							item.topLevelDomains.forEach(function (tld) {
								item.dest.push({"display_name": tld, "type": "TLD", id: tld, "name": tld})
							});
						}

						if (item.ips) {
							item.ips.split(',').forEach(function (ip) {
								item.dest.push({"display_name": ip, "type": "IP", id: ip, "name": ip})
							});
						}

						if (item.ports) {
							item.ports.split(',').forEach(function (port) {
								item.dest.push({"display_name": port, "type": "PORT", id: port, "name": port})
							});
						}

						item.dest = item.dest.concat(item.apps);
					}
				}

				return items;
			}
		},
		health: {
			generalFetch: true,
			sortButton: true,
			clientSideSort: true,
			ruleCollection: 'healthRules',
			type: 'HealthRule',
			systemGroupsLimit: true,
			redirect: window.location.origin + '/#!/' + $state.params.accountId + '/alertRules',
			constraints: ['connectivity', 'quality'],
			types: function() {
				var that = this;
				if (that.healthTypesCache) {
					return that.healthTypesCache;
				}
				that.healthTypesCache = [{
				        id:'Disconnect',
				        name:'Connectivity'
				    }, {
				        id:'Quality',
				        name:'Quality'
				    }];
				return that.healthTypesCache;
			},
			healthTypesCache: null,
			preFields: [
				{
					label: 'Type',
					path: 'type',
					template: "<select ng-model='item.healthType' class='form-control alert-type-selector'><option value=''>Select Type</option><option ng-repeat='healthType in tableConfig.types()  track by healthType.id' value='{{healthType.id}}'>{{healthType.name}}</option></select>",
					noSort: true
				}
			],
			customFields: [
				{
				    groupedFields: [ {
				        predicate: function(item) {
				            return item.healthType === 'Disconnect'
				        },
                        label: 'On',
                        path: 'connectivityRuleType',
                        template: "<div class='connectivityRuleTypes-selector-wrapper'>On:<br/>"+
                                "<entry-list items='item.connectivityRuleTypes' root='item' field='connectivityRuleTypes' id='connectivityRuleType_{{$parent.$index}}' add-items='tableConfig.selectConnectivityRuleType(item,field,id)' icons='tableConfig.icons'></entry-list></div>",
                        noSort: true,
				    }, {
				        predicate: function(item) {
                            return item.healthType === 'Quality'
                        },
                        label: 'Interface',
                        path: 'interface',
                        template:  "<div>Interface:<br/>" +
                                        "<interface-selection model='item.sourceInterfaces' id='interface-selection-{{$parent.$index}}' icons='tableConfig.icons'></interface-selection>" +
                                   "</div>",
                        noSort: true,
                    }]
                },
				{
				    label: 'Thresholds',
                    path: 'thresholds',
                    template:   "<expandable-section label='{{item.alertConstraint.qualityConstraint.thresholdsLabel}}' on-expand-event='item.alertConstraint.qualityConstraint.thresholdsLabel = \"Thresholds\"' on-collapse-event='item.alertConstraint.qualityConstraint.thresholdsLabel = \"Trigger for any of the below thresholds\"' one-liner='false' summary='{{tableConfig.getThresholdsSummary(item.alertConstraint.qualityConstraint.thresholds)}}' initially-collapsed='tableConfig.getStatus(item)!==\"new\"' fire-event-on-init=true ng-if='item.healthType===\"Quality\"'>" +
                                    "<div>" +
                                        "<div class='info-text'><span class='glyphicon glyphicon-info-sign'></span>&nbspAlert triggers for any of these thresholds</div>" +
                                        "<stat-threshold caption='Packet Loss (%)' model='item.alertConstraint.qualityConstraint.thresholds.packetLoss' change-listener='item.alertConstraint.qualityConstraint.thresholds.packetLoss = value' errors='errors'></stat-threshold>" +
                                        "<br/>" +
                                        "<stat-threshold caption='Distance (msec)' model='item.alertConstraint.qualityConstraint.thresholds.distance' change-listener='item.alertConstraint.qualityConstraint.thresholds.distance = value' errors='errors'></stat-threshold>" +
                                        "<br/>" +
                                        "<stat-threshold caption='Jitter (msec)' model='item.alertConstraint.qualityConstraint.thresholds.jitter' change-listener='item.alertConstraint.qualityConstraint.thresholds.jitter = value' errors='errors'></stat-threshold>" +
                                        "<br/>" +
                                        "<div class='stat-congestion'>" +
                                            "<div class='checkbox'>" +
                                                "<label>" +
                                                    "<input type='checkbox' ng-model='item.alertConstraint.qualityConstraint.thresholds.congestion'>" +
                                                    "<span class='label'> Congestion</span>" +
                                                "</label>" +
                                            "</div>" +
                                        "</div>" +
                                        "<br/><br/>" +
                                        "<form-input class='stat-direction' label='Direction:' label-width='3'>" +
                                            "<select class='form-control' ng-model='item.alertConstraint.qualityConstraint.thresholds.target' ng-options='targetType as targetType for targetType in [\"any\", \"upstream\", \"downstream\"]'></select>" +
                                        "</form-input>" +
                                    "</div>" +
                                "</expandable-section>",
                    noSort: true,
				}
			],
			fields: [
				{
					class: 'toggle-status',
					label: 'Status',
					path: 'enabled',
					template: "<span ng-show='item.id > 0'><span class='current'>{{item.enabled? 'Enabled' : 'Disabled'}}</span><span class='change-status' ng-click='tableConfig.toggleRuleStatus(item, item.enabled)'>{{item.enabled? 'Disable' : 'Enable'}}</span></span>",
					noSearch: true
				},
				{
					class: 'entry-list',
					label: 'Source',
					path: 'source',
					template: "<span><entry-list items='item.source' root='item' field='source' id='source_{{$parent.$index}}' add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true
				},
				{
					label: 'Description',
					path: 'description',
					template: "<textarea ng-model='item.description' rows='3'></textarea>",
					noSort: true
				},
				$scope.triggerConfig,
				{
					label: 'Last Modified',
					path: 'lastModified',
					template: "<span><time am-time-ago='item.lastModified'></time></span>",
					noSort: false,
					noSearch: true
				},
			],
		},
		geo: {
			generalFetch: false,
			sortButton: true,
			ruleCollection: 'rules',
			type: 'AvRule',
			tableTitle: 'Geo Restriction Policies',
			noLimit: true,
			titleSearch: true,
			title: 'Countries',
			defaultAction: 'BLOCK',
			constraints: [],
			directions: [
				{
					value: 'TO', name: 'Outbound',
				},
				{
					value: 'FROM', name: 'Inbound',
				},
				{
					value: 'BOTH', name: 'Both Directions',
				},
			],
			fromText: 'Countries',
			fields: [
				{
					class: 'toggle-status',
					label: 'Status',
					path: 'enabled',
					template: "<span ng-show='item.id > 0'><span class='current'>{{item.enabled? 'Enabled' : 'Disabled'}}</span><span class='change-status' ng-click='tableConfig.toggleRuleStatus(item, item.enabled)'>{{item.enabled? 'Disable' : 'Enable'}}</span></span>",
					noSearch: true
				},
				{
					class: 'entry-list',
					label: 'Country',
					path: 'source',
					template: "<span><entry-list items='item.source' root='item' field='source' id='source_{{$parent.$index}}' add-items='tableConfig.selectCountries(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true
				},
				{
					label: 'Description',
					path: 'description',
					template: "<textarea ng-model='item.description' rows='3'></textarea>",
					noSort: true
				},
				$scope.triggerConfig,
				{
					label: 'Last Modified',
					path: 'lastModified',
					template: "<span><time am-time-ago='item.lastModified'></time></span>",
					noSort: false,
					noSearch: true
				},
			],
			customFields: [
				{
					class: 'customDirection',
					label: 'Direction',
					path: 'dir',
					template: "<select ng-model='item.dir' class='form-control' ng-options='direction.value as direction.name for direction in tableConfig.directions'></select>",
					noSort: true,
					noSearch: true
				},
				{
					label: 'Action',
					path: 'action',
					template: "<div class='action-wrapper' ng-attr-title='{{tableConfig.actionData[item.action].name}}' title='{{tableConfig.actionData[item.action].name}}'><svg id='action_{{item.id}}' title='{{tableConfig.actionData[item.action].name}}.Click to change' class='url-action-button {{tableConfig.actionData[item.action].class}} icon icon-{{tableConfig.actionData[item.action].icon}}' ng-click='tableConfig.changeAction(item)'><use xlink:href='' ng-href='/public/images/icons/main.svg#icon-url-{{tableConfig.actionData[item.action].icon}}'></use></svg></div>"
				},
			],
			ruleActions: ['BLOCK', 'MONITOR'],
			actionData: {
				BLOCK: {name: 'Block', icon: 'block', class: 'action-block'},
				MONITOR: {name: 'Monitor', icon: 'monitor', class: 'action-monitor'},
			},
			changeAction: function (item) {
				const options = {"absolute": true};
				$scope.$root.$emit('$openPopup', this.ruleCollection + '-actions', 'action_' + item.id, options);
				this.actionsConfig.selectedAction = item.action;
				this.actionsConfig.rule = item;
			},
			actionsConfig: {
				selectedAction: null,
			},
			setAction: function () {
				this.actionsConfig.rule.action = this.actionsConfig.selectedAction;
				$scope.$root.$emit('$closePopup', this.ruleCollection + '-actions');
				//        $scope.actionsConfig.selectedAction = null;
			},
			noDirectionField: true,
			selectIdentifier: 'code',
			parseData: function () {
				return angular.copy($scope.origGeoRules) || [];
			},
		},
		local: {
			generalFetch: false,
			sortButton: true,
			destination: {
				class: 'entry-list',
				label: 'Destination',
				path: 'destination',
				template: "<span><entry-list items='item.destination' root='item' field='destination' id='destination_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
				noSort: true
			},
			ruleCollection: 'localRoutingRules',
			type: 'localRoutingRules',
			titleSearch: false,
			title: 'Local Routing Rules',
			noLimit: true,
			noCommands: true,
			dataURL: function () {
				return null;
			},
			defer: true,
			parseData: $scope.parseLocalRoutingRules,
			defaultAction: 'ALLOW',
			exceptionAction: 'BLOCK',
			redirect: window.location.origin + '/#!/' + $state.params.accountId + '/sites/',
			confirm: 'internal connectivity restrictions',
			tableTitle: 'Connections',
			constraints: [],
			restrictionType: 'accessRules',
			fields: [
				{
					class: 'toggle-status',
					label: 'Status',
					path: 'enabled',
					template: "<span ng-show='item.id > 0'><span class='current'>{{item.enabled? 'Enabled' : 'Disabled'}}</span><span class='change-status' ng-click='tableConfig.toggleRuleStatus(item, item.enabled)'>{{item.enabled? 'Disable' : 'Enable'}}</span></span>",
					noSearch: true
				},
				{
					class: 'entry-list',
					label: 'Source',
					path: 'source',
					template: '<span><entry-list' +
					" items='item.source' root='item' field='source' id='source_{{tableConfig.ruleAction + $parent.$index}}'  add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true,
					searchField: 'name'
				},
				{
					class: 'direction',
					label: 'Direction',
					path: 'dir',
					template: "<img ng-click='tableConfig.changeDir(item)' alt='Click to change direction' ng-src='/public/images/{{item.dir}}.png'/>",
					noSort: true,
					noSearch: true
				},
				{
					class: 'entry-list',
					label: 'Destination',
					path: 'destination',
					template: "<span><entry-list items='item.destination' root='item' field='destination' id='destination_{{tableConfig.ruleAction + $parent.$index}}' add-items='tableConfig.select(item,field,id)' icons='tableConfig.icons'></entry-list></span>",
					noSort: true,
					searchField: 'name'
				},
				{
					class: 'constraint',
					label: 'Limit to',
					path: 'constraint',
					template: "<span><constraint id='tableConfig.ruleAction' item='item' config='tableConfig' index='$parent.$index'/></span>",
					noSort: true,
					noSearch: true
				},
				{
					class: 'constraint',
					label: 'Limit to',
					path: 'constraint',
					template: "<span><constraint id='tableConfig.ruleAction' item='item' config='tableConfig' index='$parent.$index'/></span>",
					noSort: true,
					noSearch: true
				},
				{
					label: 'Description',
					path: 'description',
					template: "<textarea  ng-model='item.description'></textarea>",
					noSort: true
				},
				$scope.triggerConfig,
				{
					label: 'Last Modified',
					path: 'lastModified',
					template: "<span><time am-time-ago='item.lastModified'></time></span>",
					noSort: false,
					noSearch: true
				},
			],
			customFields: [
				{
					label: 'Track',
					path: 'track',
					class: 'commands',
					template: "<div id='limit_{{tableConfig.ruleAction + $parent.$index}}' class='inline-block withripple icon-wrapper constraint-icon' ng-click='tableConfig.editTrigger(item,tableConfig.ruleAction + $parent.$index)'><svg class='icon icon-limit' ng-class='{on: ((item.allowTCP || item.allowUDP || item.allowICMP || item.ports ))}'  ng-mouseenter='showportprotocol()' ng-mouseleave='showportprotocoltip = false'><use xlink:href='/public/images/icons/main.svg#icon-limit'></use></svg></div>",
					noSort: true
				},
			],

		},
	};


	$controller('BasePolicyFormCtrl', {
		$scope: $scope,
		$location: $location,
		$timeout: $timeout,
		rulesDef: rulesDef,
		$state: $state,
		$filter: $filter,
		IconsService: IconsService,
		GeneralUtilsService: GeneralUtilsService
	});

    // I believe that the below assignments should be removed because we already have the ruleDef
    // in the parent controller scope: BasePolicyFormController.$scope.ruleDef but not sure because we
    // modifieng the
//	var ruleDef = rulesDef[$state.current.rule];
	var ruleCollection = $scope.ruleDef.ruleCollection;
	var ruleType = $scope.ruleDef.type;

	function refreshAccount(data) {
		$timeout(function () {
			$scope.account = data;
			if (typeof $scope.account[$scope.ruleDef.enabledAttrib] === 'undefined') {
				$scope.account[$scope.ruleDef.enabledAttrib] = angular.copy(data.enabled);
			}

			if (!$scope.account.rules && data[ruleCollection]) {
				$scope.account.rules = data[ruleCollection];
				if ($scope.ruleDef.enabledAttrib) {
					$scope.account.enabled = data[$scope.ruleDef.enabledAttrib];
				}
			}
			$scope.exceptionsdatamodified = new Date().getTime();
			$scope.datamodified = new Date().getTime();
			$scope.mailingLists = [];
			data.mailingDefinition.mails.forEach(function (list) {
				$scope.mailingLists.push(list.name);
			});
		}, 0);
	}

	if ($scope.ruleDef.generalFetch) {
		store.fetch({
			path: 'getAccountRules',
			queryParams: {
				accountId: $state.params.accountId,
				fieldName: ruleCollection,
				ruleId: $state.params.ruleId,
				enabledFieldName: $scope.ruleDef.enabledAttrib ? $scope.ruleDef.enabledAttrib : ''
			},
			success: function (data) {
				refreshAccount(data);
			},
		});
	}

	store.fetch({
		method: 'POST',
		path: '/users',
		queryParams: {
			accountId: $state.params.accountId,
		},
		success: function (data) {
			$scope.admins = data.items;
		},
	});

    $scope.saveRules = function (configs) {
        if (!(configs instanceof Array)) {
        	configs = [configs];
        }

        var items = [];
        configs.forEach(function (config) {
        	config.items.forEach(function (rule) {
        		var orig = $scope.origRules[rule.id];
        		if (typeof config.preSave === 'function') {
        			config.preSave(rule);
        		}

        		if (!orig || !angular.equals(rule, orig)) {
        			rule.changed = true;
        		}
        	});

        	items = items.concat(config.items);
        });

        $scope.account[ruleCollection] = items;
        $scope.account[$scope.ruleDef.enabledAttrib] = $scope.account.enabled;
        $scope.doSave('Rules saved successfully', null, configs, [ruleCollection, $scope.ruleDef.enabledAttrib]);
        configs.forEach(function (config) {
        	$scope.account[ruleCollection].forEach(function (rule) {
        		if (typeof config.postSave === 'function') {
        			config.postSave(rule);
        		}
        	});
        });
    }

	$scope.saveChanges = function(){
        $scope.saveRules($scope.rulesConfig);
	};

	$scope.doSave = function (message, onSuccess, config, fields) {
		if (!fields) {
			fields = [];
		}

		$scope.loading = true;
		$scope.account.newSaveMethod = true;
		store.save({
			path: '/edit',
			data: $scope.account,
			dataObj: 'json',
			queryParams: {accountId: $state.params.accountId, save: true, fields: angular.toJson(fields)},
			success: function (data) {
				$scope.loading = false;
				$scope.$root.handleServerResponse(data, '', message, onSuccess);
				if (data.status !== 'ERROR') {
					refreshAccount(data.model);
				}
			},
		});
	};

    $scope.addQualityItems = function () {
		if ($scope.allowAnyItems) {
			$scope.allowAny();
			$scope.$root.closePopup('addQualityItem');
			return;
		}
		var curItems = [];
		var itemTypes = ['groups', 'sites'];
		for (var key in itemTypes) {
			var config = $scope[itemTypes[key] + 'Config'];
			curItems = curItems.concat(config.selectedItems);
		}
		$scope.scopeSelection.item[$scope.scopeSelection.type] = curItems;
		$scope.$root.closePopup('addQualityItem');
	};

	$scope.addItems = function () {
		if ($scope.allowAnyItems) {
			$scope.allowAny();
			$scope.$root.closePopup('addItem');
			return;
		}
		var curItems = [];
		var itemTypes = ['groups', 'sites', 'subnets', 'accesslogins', 'ipRanges','floatingIps', 'dsUser', 'ifaces', 'ips'];
		for (var key in itemTypes) {
			var config = $scope[itemTypes[key] + 'Config'];
			if (itemTypes[key] === 'ips') {
				if (config.selectedItems) {
					config.selectedItems.split(',').forEach(function(ip) {
						ip = ip.trim();
						if (ip !== '') {
							curItems.push({
								entityType: 'IP',
								pid: 0,
								id: 0,
								name: ip,
								type: 'IP',
							});
						}
					});
				}

			}
			else if (itemTypes[key] === 'floatingIps'){
			    curItems = addFloatingIpsAndUpdateDisplayName(curItems, config.selectedItems);
			}
			else {
				curItems = curItems.concat(config.selectedItems);
			}

		}
		$scope.scopeSelection.item[$scope.scopeSelection.type] = curItems;
		$scope.$root.closePopup('addItem');
	};

    //adding display_name and entity type to selected items (to show ip range name instead of name which is the name of the subnet type)
    //adding the selected items to the current table items
	function addFloatingIpsAndUpdateDisplayName(curItems, selectedItems){
	    selectedItems.forEach(function(item){
            updateFloatingIpParameters(item);
	    });

	    return curItems.concat(selectedItems);
	 }

	 //updates floating ip display_name if doesn't exist
	 function updateFloatingIpParameters(item){
        item.display_name = item.display_name ?  item.display_name : item.floatingRangeName;
        item.entityType = 'floatingIps'
	 }

	$scope.addAppsAndCategories = function () {
		// any item
		if ($scope.allowAnyItems) {
			$scope.allowAny();
			$scope.$root.closePopup('applications');
			return;
		}

		var curItems = [];
		var itemTypes = [{name: 'categories', type: 'AppCategory'}, {name: 'apps', type: 'App'},
			{name: 'services', type: 'Service'}, {name: 'customApps', type: 'CustomApp'}, {name: 'customCategories', type: 'CustomCategory'}];
		for (var key in itemTypes) {
			var typeDef = itemTypes[key];
			var config = $scope[typeDef.name + 'Config'];
			config.selectedItems.forEach(function (item) {
				item.type = typeDef.type;
				if (typeDef.name === 'customApps') {
					//item.id = item.appId;
					item.display_name = item.name;
					if (item.definitions) {
						delete item.definitions;
					}
				}
			});
			curItems = curItems.concat(config.selectedItems);
		}
		$scope.scopeSelection.item[$scope.scopeSelection.type] = curItems;

		if ($scope.tldConfig) {
			$scope.tldConfig.selectedItems.split(",").forEach(function(tld) {
				if (tld.trim().length > 0) {
					if (!_.find($scope.scopeSelection.item[$scope.scopeSelection.type], {'id': tld.trim()})) {
						$scope.scopeSelection.item[$scope.scopeSelection.type].push({"id":tld.trim(),"name":tld.trim(),"type":"TLD"});
					}
				}

			});
		}

		if ($scope.fqdnConfig.selectedItems) {
			$scope.fqdnConfig.selectedItems.split(",").forEach(function(fqdn) {
				if (fqdn.trim().length > 0) {
					if (!_.find($scope.scopeSelection.item[$scope.scopeSelection.type], {'id': fqdn.trim()})) {
						$scope.scopeSelection.item[$scope.scopeSelection.type].push({"id":fqdn.trim(),"name":fqdn.trim(),"type":"FQDN"});
					}
				}
			});
		}

		if ($scope.fqdnConfig.selectedItems) {
			$scope.fqdnConfig.selectedItems.split(",").forEach(function(fqdn) {
				if (fqdn.trim().length > 0) {
					if (!_.find($scope.scopeSelection.item[$scope.scopeSelection.type], {'id': fqdn.trim()})) {
						$scope.scopeSelection.item[$scope.scopeSelection.type].push({"id":fqdn.trim(),"name":fqdn.trim(),"type":"FQDN"});
					}
				}
			});
		}

		if ($scope.ipsConfig.selectedItems) {
			$scope.ipsConfig.selectedItems.split(",").forEach(function(ip) {
				if (ip.trim().length > 0) {
					if (!_.find($scope.scopeSelection.item[$scope.scopeSelection.type], {'id': ip.trim()})) {
						$scope.scopeSelection.item[$scope.scopeSelection.type].push({"id":ip.trim(),"name":ip.trim(),"type":"IP"});
					}
				}
			});
		}

		if ($scope.portsConfig.selectedItems) {
			$scope.portsConfig.selectedItems.split(",").forEach(function(port) {
				if (port.trim().length > 0) {
					if (!_.find($scope.scopeSelection.item[$scope.scopeSelection.type], {'id': port.trim()})) {
						$scope.scopeSelection.item[$scope.scopeSelection.type].push({"id":port.trim(),"name":port.trim(),"type":"PORT"});
					}
				}
			});
		}

		$scope.$root.closePopup('applications');
	};

	$scope.addCountries = function () {
		// any item
		if ($scope.allowAnyItems) {
			$scope.allowAny();
			$scope.$root.closePopup('addItem');
			return;
		}

		var curItems = [];
		var itemTypes = [{name: 'countries', type: 'Country'}];
		for (var key in itemTypes) {
			var typeDef = itemTypes[key];
			var config = $scope[typeDef.name + 'Config'];
			config.selectedItems.forEach(function (item) {
				item.type = typeDef.type;
			});
			curItems = curItems.concat(config.selectedItems);
		}
		$scope.scopeSelection.item[$scope.scopeSelection.type] = curItems;
		$scope.$root.closePopup('addItem');
	};

	$scope.selectedApps = [];

	$scope.selectApp = function (app) {
		GeneralUtilsService.toggleSelection($scope.selectedApps, app.id);
	};


	$scope.sitesConfig = {
		fixedLayout: true,
		titleSearch: true,
		dataURL: function () {
			return '/sites?accountId=' + $state.params.accountId;
		},
		fields: [{label: 'Name', path: 'name', template: '<span>{{item.name}}</span>'},
			{label: 'Address', path: 'address', template: '<span>{{item.address}}</span>'},
		],
		type: 'Site',
		actions: [],
		selectedItems: [],
		pageSize: 5,
	};

	$scope.accessloginsConfig = {
		titleSearch: true,
		searchFields: ['email'],
		statusNames: {
			DISABLED: 'Disabled',
			ACTIVE: 'Configured',
			SUSPENDED: 'Suspended',
			NEW: 'New',
			PENDING_USER_CONFIGURATION: 'Invitation Sent'
		},
		loginNameById: {},
		dataURL: function () {
			return '/logins?accountId=' + $state.params.accountId;
		},
		fields: [{label: 'Name', path: 'name', template: '<span>{{item.name}}<span>'},
			{label: 'E-mail', path: 'email'},
		],
		type: 'AccessLogin',
		actions: [],
		selectedItems: [],
		pageSize: 5,
	};

	$scope.groupsConfig = {
		fixedLayout: true,
		titleSearch: true,
		dataURL: function () {
		    var systemGroupsLimit = $scope.ruleDef.systemGroupsLimit ? "&systemGroupsLimit=healthRule" : "";
            return '/groups?accountId=' + $state.params.accountId + systemGroupsLimit;
		},
		fields: [{label: 'Name', path: 'name', template: '<span>{{item.prefix}}{{item.name}}</span>'},
			{label: 'Description', path: 'description', template: '<span>{{item.description}}</span>'},
		],
		type: 'Group',
		actions: [],
		selectedItems: [],
		pageSize: 5,
	};

	$scope.ifacesConfig = {
		fixedLayout: true,
		dataURL: function () {
			if ($scope.site && $scope.site.id)
				return "/getInterfaces?siteId=" + $scope.site.id;
			return '/getInterfaces?accountId=' + $state.params.accountId;
		},
		fields: [{label: 'Name', path: 'name', template: '<span>{{item["display_name"] || item.name}}</span>'},
			{label: 'Destination', path: 'siteName', template: '<span>{{item.destType.value | capitalize}}</span>'},
			{label: 'Interface ', path: 'interfaceName', template: '<span>{{item.interface_id}}</span>'}
		],
		type: 'IPRange',
		actions: [],
		selectedItems: [],
		pageSize: 5,

	};

	store.fetch({
		path: '/apps?accountId=' + $state.params.accountId,
		success: function (data) {
			$scope.apps = data;
			for (var key in data) {
				$scope.rulesConfig.servicesNames[data[key].id] = data[key].display_name;
			}
		},
	});

	var basicConfig = {
		titleSearch: true,
		dataURL: function () {
			return '/categories?accountId=' + $state.params.accountId;
		},
		actions: [],
		pageSize: 5,
		sortField: 'display_name',
		searchField: 'display_name',
	};

	$scope.floatingIpsConfig = {
    		fixedLayout: true,
    		titleSearch: true,
    		method: 'GET',
    		dataURL: function () {
    			return '/getFloatingIps?accountId=' + $state.params.accountId;
    		},
    		fields: [{label: 'Name', path: 'floatingRangeName', template: '<span>{{item.floatingRangeName}}</span>'},
    			{label: 'IP Range', path: 'subnet', template: '<span>{{item.subnet}}</span>'},
    		],
    		type: 'FloatingIpSubnet',
    		actions: [],
    		selectedItems: [],
    		pageSize: 5,
    		clientSidePaging: true,
    		clientSideSearch: true,
    		clientSideSort: true
    	};


	if ($scope.ruleDef.type === 'AppRule' || $scope.ruleDef.type === 'GeoRule') {
	} else if ($scope.ruleDef.type === 'TrafficLoggingRule') {
		// for constraint
		$scope.rulesConfig.constraintName = 'TrafficRule';
	} else {
		$scope.serviceConstraintConfig = {
			titleSearch: true,
			fields: [
				{label: 'Name', path: 'display_name', template: '<span>{{item.display_name}}</span>'},
				{"label":"Categories","path":"categories","template":"<span>{{item.categoriesDisplay}}</span>"},
			],
			type: 'Service',
			selectedItems: [],
		};
		angular.extend($scope.serviceConstraintConfig, basicConfig);
	}


	function filteredCategories() {
		$scope.categoriesConfig.filtered = true;
		$scope.appsConfig.filtered = true;
		$scope.servicesConfig.filtered = true;
	}

	filteredCategories();


    function checkNewFw() {
        if (!$scope.$root.useNewFW) {
            $scope.$root.alert('Cato migrated the rules for the security policy to the new firewall (the URL Filtering rules are migrated to the new Internet firewall). Any changes to the previous firewall rules are not applied to the new firewall. You are ONLY configuring the previous firewall.');
        }
    }
}
